import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      console.log("🟢 Access granted!");
      return true;
    } else {
      console.log("🔴 Unauthorized - redirecting to login");
      this.router.navigate(['/login']);
      return false;
    }
  }
}
